<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="ch2"><span class="epub-bi">Chapter II</span></p>
<p class="vh1"><span class="epub-sc">I</span></p>
<p class="v">Hector was there. Theophile also. In this light,</p>
<p class="v">they have only Christian names. Placide, Pancreas,</p>
<p class="vsb">Chrysostom, Maljo, Philoctete with his head white</p>
<p class="v">as the coiled surf. They shipped the lances of oars,</p>
<p class="v">placed them parallel in the grave of the gunwales</p>
<p class="vsb">like man and wife. They scooped the leaf-bilge from the planks,</p>
<p class="v">loosened knots from the bodies of flour-sack sails,</p>
<p class="v">while Hector, at the shallows’ edge, gave a quick thanks,</p>
<p class="vsb">with the sea for a font, before he waded, thigh-in.</p>
<p class="v">The rest walked up the sand with identical stride</p>
<p class="v">except for foam-haired Philoctete. The sore on his shin</p>
<p class="vsb">still unhealed, like a radiant anemone. It had come</p>
<p class="v">from a scraping, rusted anchor. The pronged iron</p>
<p class="v">peeled the skin in a backwash. He bent to the foam,</p>
<p class="vsb">sprinkling it with a salt hiss. Soon he would run,</p>
<p class="v">hobbling, to the useless shade of an almond,</p>
<p class="v">with locked teeth, then wave them off from the shame</p>
<p class="vsb">of his smell, and once more they would leave him alone</p>
<p class="v">under its leoparding light. This sunrise the same</p>
<p class="v">damned business was happening. He felt the sore twitch</p>
<p class="vsb">its wires up to his groin. With his hop-and-drop</p>
<p class="v">limp, hand clutching one knee, he left the printed beach</p>
<p class="v">to crawl up the early street to Ma Kilman’s shop.</p>
<p class="vsb">She would open and put the white rum within reach.</p>
<p class="v">His shipmates watched him, then they hooked hands like anchors</p>
<p class="v">under the hulls, rocking them; the keels sheared dry sand</p>
<p class="vsb">till the wet sand resisted, rattling the oars</p>
<p class="v">that lay parallel amidships; then, to the one sound</p>
<p class="v">of curses and prayers at the logs jammed as a wedge,</p>
<p class="vsb">one after one, as their tins began to rattle,</p>
<p class="v">the pirogues slid to the shallows’ nibbling edge,</p>
<p class="v">towards the encouraging sea. The loose logs swirled</p>
<p class="vsb">in surf, face down, like warriors from a battle</p>
<p class="v">lost somewhere on the other shore of the world.</p>
<p class="v">They were dragged to a place under the manchineels</p>
<p class="vsb">to lie there face upward, the sun moving over their brows</p>
<p class="v">with the stare of myrmidons hauled up by the heels</p>
<p class="v">high up from the tide-mark where the pale crab burrows.</p>
<p class="vsb">The fishermen brushed their palms. Now all the canoes</p>
<p class="v">were riding the pink morning swell. They drew their bows</p>
<p class="v">gently, the way grooms handle horses in the sunrise,</p>
<p class="vsb">flicking the ropes like reins, pinned them by the nose—</p>
<p class="v"><span class="epub-i">Praise Him, Morning Star, St. Lucia, Light of My Eyes,</span></p>
<p class="v">threw bailing tins in them, and folded their bodies across</p>
<p class="vsb">the tilting hulls, then sculled one oar in the slack</p>
<p class="v">of the stern. Hector rattled out his bound canvas</p>
<p class="v">to gain ground with the gulls, hoping to come back</p>
<p class="v">before that conch-coloured dusk low pelicans cross.</p>
<p class="vh"><span class="epub-sc">II</span></p>
<p class="v">Seven Seas rose in the half-dark to make coffee.</p>
<p class="v">Sunrise was heating the ring of the horizon</p>
<p class="vsb">and clouds were rising like loaves. By the heat of the</p>
<p class="v">glowing iron rose he slid the saucepan’s base on-</p>
<p class="v">to the ring and anchored it there. The saucepan shook</p>
<p class="vsb">from the weight of water in it, then it settled.</p>
<p class="v">His kettle leaked. He groped for the tin chair and took</p>
<p class="v">his place near the saucepan to hear when it bubbled.</p>
<p class="vsb">It would boil but not scream like a bosun’s whistle</p>
<p class="v">to let him know it was ready. He heard the dog’s</p>
<p class="v">morning whine under the boards of the house, its tail</p>
<p class="vsb">thudding to be let in, but he envied the pirogues</p>
<p class="v">already miles out at sea. Then he heard the first breeze</p>
<p class="v">washing the sea-almond’s wares; last night there had been</p>
<p class="vsb">a full moon white as his plate. He saw with his ears.</p>
<p class="v">He warmed with the roofs as the sun began to climb.</p>
<p class="v">Since the disease had obliterated vision,</p>
<p class="vsb">when the sunset shook the sea’s hand for the last time—</p>
<p class="v">and an inward darkness grew where the moon and sun</p>
<p class="v">indistinctly altered—he moved by a sixth sense,</p>
<p class="vsb">like the moon without an hour or second hand,</p>
<p class="v">wiped clean as the plate that he now began to rinse</p>
<p class="v">while the saucepan bubbled; blindness was not the end.</p>
<p class="vsb">It was not a palm-tree’s dial on the noon sand.</p>
<p class="v">He could feel the sunlight creeping over his wrists.</p>
<p class="v">The sunlight moved like a cat along the palings</p>
<p class="vsb">of a sandy street; he felt it unclench the fists</p>
<p class="v">of the breadfruit tree in his yard, run the railings</p>
<p class="v">of the short iron bridge like a harp, its racing</p>
<p class="vsb">stick rippling with the river; he saw the lagoon</p>
<p class="v">behind the church, and in it, stuck like a basin,</p>
<p class="v">the rusting enamel image of the full moon.</p>
<p class="vsb">He lowered the ring to sunset under the pan.</p>
<p class="v">The dog scratched at the kitchen door for him to open</p>
<p class="v">but he made it wait. He drummed the kitchen table</p>
<p class="vsb">with his fingers. Two blackbirds quarrelled at breakfast.</p>
<p class="v">Except for one hand he sat as still as marble,</p>
<p class="v">with his egg-white eyes, fingers recounting the past</p>
<p class="vsb">of another sea, measured by the stroking oars.</p>
<p class="v">O open this day with the conch’s moan, Omeros,</p>
<p class="v">as you did in my boyhood, when I was a noun</p>
<p class="vsb">gently exhaled from the palate of the sunrise.</p>
<p class="v">A lizard on the sea-wall darted its question</p>
<p class="v">at the waking sea, and a net of golden moss</p>
<p class="vsb">brightened the reef, which the sails of their far canoes</p>
<p class="v">avoided. Only in you, across centuries</p>
<p class="v">of the sea’s parchment atlas, can I catch the noise</p>
<p class="vsb">of the surf lines wandering like the shambling fleece</p>
<p class="v">of the lighthouse’s flock, that Cyclops whose blind eye</p>
<p class="v">shut from the sunlight. Then the canoes were galleys</p>
<p class="vsb">over which a frigate sawed its scythed wings slowly.</p>
<p class="v">In you the seeds of grey almonds guessed a tree’s shape,</p>
<p class="v">and the grape leaves rusted like serrated islands,</p>
<p class="vsb">and the blind lighthouse, sensing the edge of a cape,</p>
<p class="v">paused like a giant, a marble cloud in its hands,</p>
<p class="v">to hurl its boulder that splashed into phosphorous</p>
<p class="vsb">stars; then a black fisherman, his stubbled chin coarse</p>
<p class="v">as a dry sea-urchin’s, hoisted his flour-sack</p>
<p class="v">sail on its bamboo spar, and scanned the opening line</p>
<p class="vsb">of our epic horizon; now I can look back</p>
<p class="v">to rocks that see their own feet when light nets the waves,</p>
<p class="v">as the dugouts set out with ebony captains,</p>
<p class="vsb">since it was your light that startled our sunlit wharves</p>
<p class="v">where schooners swayed idly, moored to their cold capstans.</p>
<p class="v">A wind turns the harbour’s pages back to the voice</p>
<p class="v">that hummed in the vase of a girl’s throat: “Omeros.”</p>
<p class="vh"><span class="epub-sc">III</span></p>
<p class="v">“O-meros,” she laughed. “That’s what we call him in Greek,”</p>
<p class="v">stroking the small bust with its boxer’s broken nose,</p>
<p class="vsb">and I thought of Seven Seas sitting near the reek</p>
<p class="v">of drying fishnets, listening to the shallows’ noise.</p>
<p class="v">I said: “Homer and Virg are New England farmers,</p>
<p class="vsb">and the winged horse guards their gas-station, you’re right.”</p>
<p class="v">I felt the foam head watching as I stroked an arm, as</p>
<p class="v">cold as its marble, then the shoulders in winter light</p>
<p class="vsb">in the studio attic. I said, “Omeros,”</p>
<p class="v">and <span class="epub-i">O</span> was the conch-shell’s invocation, <span class="epub-i">mer</span> was</p>
<p class="v">both mother and sea in our Antillean patois,</p>
<p class="vsb"><span class="epub-i">os,</span> a grey bone, and the white surf as it crashes</p>
<p class="v">and spreads its sibilant collar on a lace shore.</p>
<p class="v">Omeros was the crunch of dry leaves, and the washes</p>
<p class="vsb">that echoed from a cave-mouth when the tide has ebbed.</p>
<p class="v">The name stayed in my mouth. I saw how light was webbed</p>
<p class="v">on her Asian cheeks, defined her eyes with a black</p>
<p class="vsb">almond’s outline, as Antigone turned and said:</p>
<p class="v">“I’m tired of America, it’s time for me to go back</p>
<p class="v">to Greece. I miss my islands.” I write, it returns—</p>
<p class="vsb">the way she turned and shook out the black gust of hair.</p>
<p class="v">I saw how the surf printed its lace in patterns</p>
<p class="v">on the shore of her neck, then the lowering shallows</p>
<p class="vsb">of silk swirled at her ankles, like surf without noise,</p>
<p class="v">and felt that another cold bust, not hers, but yours</p>
<p class="v">saw this with stone almonds for eyes, its broken nose</p>
<p class="vsb">turning away, as the rustling silk agrees.</p>
<p class="v">But if it could read between the lines of her floor</p>
<p class="v">like a white-hot deck uncaulked by Antillean heat,</p>
<p class="vsb">to the shadows in its hold, its nostrils might flare</p>
<p class="v">at the stench from manacled ankles, the coffled feet</p>
<p class="v">scraping like leaves, and perhaps the inculpable marble</p>
<p class="vsb">would have turned its white seeds away, to widen</p>
<p class="v">the bow of its mouth at the horror under her table,</p>
<p class="v">from the lyre of her armchair draped with its white chiton,</p>
<p class="vsb">to do what the past always does: suffer, and stare.</p>
<p class="v">She lay calm as a port, and a cloud covered her</p>
<p class="v">with my shadow; then a prow with painted eyes</p>
<p class="vsb">slowly emerged from the fragrant rain of black hair.</p>
<p class="v">And I heard a hollow moan exhaled from a vase,</p>
<p class="v">not for kings floundering in lances of rain; the prose</p>
<p class="v">of abrupt fishermen cursing over canoes.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?0dba28df